<template>
<div class="row page-titles">
  <div class="col-md-5 align-self-center">
    <h4 class="text-themecolor">{{$parent.pageTitle}}</h4>
  </div>
  <div class="col-md-7 align-self-center text-right">
    <div class="d-flex justify-content-end align-items-center">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link :to="{name:'Home'}">Home</router-link></li>
        <li class="breadcrumb-item active">{{$parent.pageTitle}}</li>
      </ol>
      <template>
        <router-link v-if="$parent.isList && !noAdd"
          :to="{name:$route.name, params:{pageSlug:'add'}}" 
          class="btn btn-rounded btn-info d-lg-block m-l-15">
          <i class="fa fa-plus-circle"></i> Add New {{$parent.pageTitle}}
        </router-link>
        <router-link v-else-if="!$parent.isList"
          :to="{name:$route.name}" 
          class="btn btn-rounded btn-info d-lg-block m-l-15">
          <i class="fas fa-list-ul m-r-15"></i>{{$parent.pageTitle}} List
        </router-link>
        <slot name="button"></slot>

      </template>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props:{
    sortingBtn:Boolean,
    deleteBtn:Boolean,
    singlePage:Boolean,
    noAdd:Boolean,
    noList:Boolean,
    noHeaderEl:Boolean
  }
}
</script>